<template>
  <offer-modal
    v-if="showOfferDetailsModal"
    :placement-id="model.placement_id"
    :offer-template-ids="[offerTemplateId]"
    @close="showOfferDetailsModal = false"
    @offer-created="incrementOfferCount"
  />
  <template v-if="showButton">
    <button
      v-if="model.offers_count"
      v-tooltip="$t('DEALS.DEAL_PROGRESS.ADD_OFFER')"
      class="flex items-center justify-center px-0.5 pr-1 text-xl leading-none font-semibold text-primary"
      @click.stop="showOfferDetailsModal = true"
    >
      <span class="-mt-0.5">+</span>
    </button>
    <primary-button
      v-else
      :disabled="offersLoading"
      @click.stop="showOfferDetailsModal = true"
    >
      {{ $t("DEALS.DEAL_PROGRESS.CREATE_OFFER") }}
    </primary-button>
  </template>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useStore } from "vuex";

import PrimaryButton from "@/components/ui/buttons/PrimaryButton.vue";
import OfferModal from "@/views/deals/components/OfferModal.vue";

import type { ILenderPlacement, IPlacementStatuses } from "@/models/funders";
import type { PropType } from "vue";

const props = defineProps({
  model: {
    type: Object as PropType<ILenderPlacement>,
    required: true,
  },
});

const { getters, commit } = useStore();
const showOfferDetailsModal = ref(false);

const statuses = computed<IPlacementStatuses>(
  () => getters["options/placementStatuses"]
);
const offersLoading = computed<boolean>(
  () => getters["applications/offersLoading"]
);
const offerTemplateId = computed(() => props.model.origin_offer_template_id);

const showButton = computed(() => {
  const isApproved =
    props.model.status ===
    Number(
      Object.keys(statuses.value).find(
        (key) => statuses.value[key as keyof IPlacementStatuses] === "Approved"
      ) || 0
    );

  return isApproved;
});

const incrementOfferCount = () => {
  commit(
    "applications/incrementOfferCountOnPlacement",
    props.model.placement_id
  );
};
</script>
